import { computed, ref } from "vue";
import { defineStore } from "pinia";
import type {
  WhiteListIPSResponse,
  ReadServerIPMetaResponse,
  GeoIpCountries,
} from "@shared/types/common";
import { JpuDTO } from "@shared/types/common";

export const useServerMetaDataStore = defineStore("serverMetaData", () => {
  // State
  const _serverMetaData = ref<ReadServerIPMetaResponse>({});
  const _isLoadingServerMetaData = ref<boolean>(false);

  // Getters
  const serverMetaData = computed(() => _serverMetaData.value);
  const isLoadingServerMetaData = computed(
    () => _isLoadingServerMetaData.value,
  );

  // Actions
  const setServerMetaData = (data: ReadServerIPMetaResponse) => {
    _serverMetaData.value = data;
  };

  const setIsLoadingServerMetaDataRequest = (isLoading: boolean) => {
    _isLoadingServerMetaData.value = isLoading;
  };

  const setWhitelistOfSpecificServer = (
    technicalServerName: JpuDTO["technicalServerName"],
    newWhitelist: WhiteListIPSResponse,
  ) => {
    if (!_serverMetaData.value[technicalServerName]) {
      return;
    }
    _serverMetaData.value[technicalServerName].whitelistIPMeta = newWhitelist;
  };

  const setGeoRestrictionsOfSpecificServer = (
    technicalServerName: JpuDTO["technicalServerName"],
    newGeoRestrictions: GeoIpCountries,
  ) => {
    if (!_serverMetaData.value[technicalServerName]) {
      return;
    }
    _serverMetaData.value[technicalServerName].geoIPMeta = newGeoRestrictions;
  };

  return {
    serverMetaData,
    isLoadingServerMetaData,
    setServerMetaData,
    setIsLoadingServerMetaDataRequest,
    setWhitelistOfSpecificServer,
    setGeoRestrictionsOfSpecificServer,
  };
});
